import { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetRemittanceDeclarationDetailQuery } from "../../../../store/queries/remittance";


const formatLabel = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

const useDeclarationDetail = () => {
  const { remittanceID } = useParams();
  const { data: declarationData, isFetching } =
    useGetRemittanceDeclarationDetailQuery({
      remittance_id: remittanceID,
    });

  const dData = declarationData?.data;

  const topLevelData = dData
    ? Object.keys(dData)
        .filter(
          (key) =>
            !Array.isArray(dData[key]) &&
            typeof dData[key] !== "object"
        )
        .map((key) => ({
          label: formatLabel(key),
          value: dData[key] ?? "---",
        }))
    : [];

  const priorRemittances = dData?.prior_remittances || [];

  const priorRemittanceFields = {
    amount: { label: "Amount", sortable: false },
    address: { label: "Address", sortable: false },
    date: { label: "Date", sortable: false },
  };

  const esign = dData?.esign || null;
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);

  const handleDownloadPdf = async (url) => {
    setDownloadLoading(true);
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "FORM A2.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("PDF download failed:", error);
    } finally {
      setDownloadLoading(false);
    }
  };

  const esignData = esign
    ? [
        { label: "Status", value: formatLabel(esign.status ?? "---") },
        { label: "Completed At", value: esign.completed_at ?? "---" },
        ...(esign.signed_document_url
          ? [
              {
                label: "A2 Form",
                value: (
                  <button
                    className="pro-btn pro-btn-primary pro-btn-sm"
                    style={{ padding: "6px 20px" }}
                    onClick={() => setShowPdfModal(true)}
                  >
                    View
                  </button>
                ),
              },
            ]
          : []),
      ]
    : [];

  return {
    topLevelData,
    priorRemittances,
    priorRemittanceFields,
    esign,
    esignData,
    showPdfModal,
    downloadLoading,
    setShowPdfModal,
    handleDownloadPdf,
    isFetching,
  };
};

export default useDeclarationDetail;
